/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from "react";
import { AuthenticationContext } from "../../Context";
import { getHeaders } from "../../utils/HeaderHelper";
import { Grid, Box, Link } from "@mui/material";
import FlashMessage from "../../shared/FlashMessage";
import { Stack } from "@mui/system";
import ActionRow from "./ActionRow";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import FilterListIcon from "@mui/icons-material/FilterList";
import ArrowDropUp from "@mui/icons-material/ArrowDropUp";
import { dateToString, formatToUsDateFromUTCNew } from "../../utils/DateHelper";
import FilterMenu from "../FilterMenu";
import BadgeList from "../../common/BadgeList";
import { isValid } from "date-fns";
import moment from "moment";
import DatePickerWithLabel from "../../common/DatePickerWithLabel";
import MonthHeader from "./MonthHeader";

interface Props {
  setRefreshStats: Function;
}

interface ActionQueueItem {
  due_date: string;
  action_data: any[];
}

interface ChipData {
  key: number;
  label: string;
  type: string;
}

const GlobalActionQueue: React.FC<Props> = (props) => {
  const authenticationSetting = React.useContext(AuthenticationContext);
  const [globalActionQueues, setGlobalActionQueues] = useState<any>([]);
  const [providers, setProviders] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [startDate, setStartDate] = React.useState<string>("");
  const [endDate, setEndDate] = React.useState<string>("");
  const [initialStartDate, setIinitialStartDate] = React.useState<string>("");
  const [initialEndDate, setInitialEndDate] = React.useState<string>("");
  // const [globalActionFutureDays, setGlobalActionFutureDays] =
  //   useState<number>(0);

  const [checkedAction, setCheckedAction] = React.useState<any>("All Actions");
  const [checkedProviders, setCheckedProviders] = React.useState<any[]>([]);
  const [checkedCategories, setCheckedCategories] = React.useState<any[]>([]);
  const [checkedInsuranceTypes, setCheckedInsuranceTypes] = React.useState<
    any[]
  >([]);
  const [checkedInsurancePlanNames, setCheckedInsurancePlanNames] =
    React.useState<any[]>([]);
  const [checkedProgramNames, setCheckedProgramNames] = React.useState<any[]>(
    []
  );
  const [badgeData, setBadgeData] = React.useState<ChipData[]>([]);

  const [actionTypes, setActionTypes] = useState([]);
  const [providerLists, setProviderLists] = useState([]);
  const [categories, setCategories] = useState([]);
  const [insuranceTypeOptions, setInsuranceTypeOptions] = useState<string[]>(
    []
  );
  const [insurancePlanNameOptions, setInsurancePlanNameOptions] = useState<
    string[]
  >([]);
  const [programNames, setProgramNames] = useState<string[]>([]);
  const fetchTimerRef = React.useRef<NodeJS.Timeout | null>(null);
  const hasRendered = React.useRef<boolean>(false);

  const [showCompleted, setShowCompleted] = useState<boolean>(false);
  const [sortType, setSortType] = useState<"chronological" | "priority">(
    "chronological"
  );

  useEffect(() => {
    if (fetchTimerRef.current) return;
    fetchTimerRef.current = setTimeout(() => {
      fetchProviders();
      setGlobalActionQueues([]);
      setPage(1);
      setHasMoreData(false);
      getFilterOptionsWithCounts();
      fetchActionQueues(1);
      fetchTimerRef.current = null;
    }, 400);
  }, [startDate, endDate, badgeData, showCompleted, sortType]);

  const setDateFilterDefault = () => {
    setStartDate(initialStartDate);
    setEndDate(initialEndDate);
  };

  const getFilterOptionsWithCounts = async () => {
    const queryParams = new URLSearchParams({
      start_date: startDate ? startDate : "",
      end_date: endDate ? endDate : "",
    });
    const response = await fetch(
      `/data_fetching/global_action_filter_options?${queryParams}`,
      {
        method: "GET",
        headers: getHeaders(authenticationSetting.csrfToken),
      }
    );
    const result = await response.json();

    if (result.success == false) {
      alert(result.message);
    } else {
      const data = result.resource;
      if (!hasRendered.current) {
        setStartDate(result.resource?.start_date);
        setIinitialStartDate(result.resource?.start_date);
        setEndDate(result.resource?.end_date);
        setInitialEndDate(result.resource?.end_date);
        hasRendered.current = true;
      }
      if (data.action_counts) {
        const counts = data?.action_counts[0];
        const initActionType = [
          { title: "All Actions", count: counts.all_actions_count },
          { title: "My Actions", count: counts.my_actions_count },
          {
            title: "Unassigned Actions",
            count: counts.unassigned_actions_count,
          },
          { title: "Assigned Actions", count: counts.assigned_actions_count },
          { title: "Overdue Actions", count: counts.overdue_actions_count },
        ];
        setActionTypes(initActionType);
        const initCategories = [
          { title: "ADT Notifications", count: counts.adt_alerts },
          {
            title: "Questionnaire Responses",
            count: counts.questionnaire_submissions,
          },
        ];
        setCategories(initCategories);
      }
      if (data.provider_actions) {
        const initProviders = data.provider_actions.map((provider) => {
          return {
            id: provider?.id,
            title: provider?.title,
            count: provider?.counts,
          };
        });
        setProviderLists(initProviders);
      }
      if (data.insurance_types) {
        setInsuranceTypeOptions(data.insurance_types);
      }
      if (data.insurance_plan_names) {
        setInsurancePlanNameOptions(data.insurance_plan_names);
      }
      if (data.programs) {
        setProgramNames(data.programs);
      }
    }
  };

  const fetchActionQueues = async (
    pageNumber: number,
    response_resource: any = 0
  ) => {
    if (!hasRendered.current) {
      console.log("First round not fetching");
      return;
    }

    var actionType = "";
    var providers = [];
    var advancedCategories = [];
    badgeData.map((d) => {
      if (d.type == "action") actionType = d.label;
      if (d.type == "provider") providers.push(d.key);
      if (d.type == "category") advancedCategories.push(d.label);
    });
    const insuranceTypes = checkedInsuranceTypes.join(",");
    const insurancePlanNames = checkedInsurancePlanNames.join(",");
    const programNames = checkedProgramNames.join(",");
    const queryParams = new URLSearchParams({
      page: pageNumber.toString(),
      start_date: startDate ? startDate.toString() : "",
      end_date: endDate ? endDate.toString() : "",
      action_type: actionType,
      providers: providers.join(","),
      advanced_categories: advancedCategories.join(","),
      show_overdue_completed: showCompleted.toString(),
      sort_type: sortType,
      insurance_types: insuranceTypes,
      program_names: programNames,
      insurance_plan_names: insurancePlanNames,
    });

    const response = await fetch(
      `/data_fetching/global_action_queues?${queryParams}`,
      {
        method: "GET",
        headers: getHeaders(authenticationSetting.csrfToken),
      }
    );
    if (response.status === 404) {
      window.location.href = "/not-found";
      return;
    }
    const result = await response.json();
    if (result.success == false) {
      alert(result.error);
    } else {
      if (response_resource !== 0) {
        setGlobalActionQueues((prevActions) => {
          const updatedActions = prevActions.map((prevAction) => {
            const actionData = prevAction.action_data?.find((data) => {
              const matchingStep = data.action_steps?.find((step) => {
                return step.id === response_resource.action_step_id;
              });
              return (
                data?.action_queue_id === response_resource.action_queue_id &&
                matchingStep
              );
            });
            if (actionData) {
              const matchingStep = actionData.action_steps?.find((step) => {
                return step.id === response_resource.action_step_id;
              });
              if (matchingStep) {
                matchingStep.step_status = response_resource.status;
              }
            }
            return prevAction;
          });
          return updatedActions;
        });
      } else if (pageNumber === 1) {
        // Replace existing data for first page
        setGlobalActionQueues(result.resource?.data || []);
      } else {
        // Append data for subsequent pages
        setGlobalActionQueues((prevActions) => {
          const newData = result.resource?.data || [];

          // Check if prevActions has at least one item and if the due dates match
          if (prevActions.length > 0 && newData.length > 0) {
            const lastPrevAction = prevActions[prevActions.length - 1];
            const firstNewAction = newData[0];

            // If due dates match, merge the action_data arrays
            if (lastPrevAction.due_date === firstNewAction.due_date) {
              return [
                ...prevActions.slice(0, -1),
                {
                  ...lastPrevAction,
                  action_data: [
                    ...lastPrevAction.action_data,
                    ...firstNewAction.action_data,
                  ],
                },
                ...newData.slice(1),
              ];
            }
          }

          return [...prevActions, ...newData];
        });
      }
      setHasMoreData(result.resource?.pagination?.has_more);
      setPage(pageNumber + 1);
      props.setRefreshStats(true);
    }
  };

  const fetchProviders = async () => {
    const response = await fetch(`/data_fetching/core_teams`, {
      method: "GET",
      headers: getHeaders(authenticationSetting.csrfToken),
    });
    if (response.status === 404) {
      window.location.href = "/not-found";
      return;
    }
    const result = await response.json();
    if (result.success == false) {
      alert(result.error);
    } else {
      const formattedProviders = result.resource.providers.map((provider) => ({
        id: provider.id,
        name: `${provider.last_name}, ${provider.first_name}`,
      }));
      setProviders(formattedProviders);
    }
  };

  const handleOpenFilter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLoadMore = () => {
    fetchActionQueues(page);
  };

  const handleDeleteBadge = (badgeToDelete) => {
    if (badgeToDelete?.type == "provider") {
      setCheckedProviders((badges) => {
        return badges.filter((badge) => badge !== badgeToDelete.key);
      });
    }

    if (badgeToDelete?.type == "category") {
      setCheckedCategories((badges) =>
        badges.filter((badge) => badge !== badgeToDelete.label)
      );
    }

    if (badgeToDelete?.type == "action") {
      setCheckedAction("");
    }

    if (badgeToDelete?.type == "insuranceType") {
      setCheckedInsuranceTypes((badges) =>
        badges.filter((badge) => badge !== badgeToDelete.label)
      );
    }

    if (badgeToDelete?.type == "insurancePlanName") {
      setCheckedInsurancePlanNames((badges) =>
        badges.filter((badge) => badge !== badgeToDelete.label)
      );
    }

    if (badgeToDelete?.type == "programName") {
      setCheckedProgramNames((badges) =>
        badges.filter((badge) => badge !== badgeToDelete.label)
      );
    }
  };

  React.useEffect(() => {
    const providerBadges = checkedProviders.map((provider) => ({
      key: provider,
      label: providerLists.filter((p) => p.id == provider)[0].title,
      type: "provider",
    }));

    const categoryBadges = checkedCategories.map((category) => ({
      key: category,
      label: category,
      type: "category",
    }));

    const insuranceTypeBadges = checkedInsuranceTypes.map((type) => ({
      key: type,
      label: type,
      type: "insuranceType",
    }));

    const insurancePlanNameBadges = checkedInsurancePlanNames.map((type) => ({
      key: type,
      label: type,
      type: "insurancePlanName",
    }));

    const programNameBadges = checkedProgramNames.map((type) => ({
      key: type,
      label: type,
      type: "programName",
    }));

    const actionBadge =
      checkedAction && checkedAction !== "All Actions"
        ? {
            key: checkedAction,
            label: checkedAction,
            type: "action",
          }
        : null;
    let updatedBadgeData: any[] = [];
    if (
      checkedAction === "My Actions" ||
      checkedAction === "Unassigned Actions"
    )
      updatedBadgeData = [
        actionBadge,
        ...categoryBadges,
        ...insuranceTypeBadges,
        ...insurancePlanNameBadges,
        ...programNameBadges,
      ].filter(Boolean);
    else
      updatedBadgeData = [
        actionBadge,
        ...providerBadges,
        ...categoryBadges,
        ...insuranceTypeBadges,
        ...insurancePlanNameBadges,
        ...programNameBadges,
      ].filter(Boolean);
    setBadgeData(updatedBadgeData);
  }, [
    checkedProviders,
    checkedCategories,
    checkedAction,
    checkedInsuranceTypes,
    checkedInsurancePlanNames,
    checkedProgramNames,
  ]);

  const handleStartDateChange = (date) => {
    if (date instanceof Date && isValid(date)) {
      setStartDate(dateToString(date));
    }
  };

  const handleEndDateChange = (date) => {
    if (date instanceof Date && isValid(date)) {
      setEndDate(dateToString(date));
    }
  };

  let lastDisplayedMonth = "";

  return (
    <div className="main-content-outer">
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid
          item
          xs={12}
          className="patient-edit-container patient-edit-form"
          sx={{
            display: "flex",
            position: "fixed",
            top: "245px",
            left: "120px",
            right: "20px",
            overflow: "unset",
          }}
        >
          <Grid container>
            <Grid
              className="patient-edit-header"
              container
              justifyContent="space-between"
            >
              <Grid item xs={3} display={"flex"} alignItems={"center"}>
                <p className="secondary-label" style={{ marginLeft: "0px" }}>
                  Global Action Queue
                </p>
              </Grid>
              <Grid
                xs={9}
                item
                className="global-action-queue-filter-container"
              >
                <DatePickerWithLabel
                  date={startDate}
                  setDate={setStartDate}
                  initialDate={initialStartDate}
                  label="Due Date From"
                />
                <DatePickerWithLabel
                  date={endDate}
                  setDate={setEndDate}
                  initialDate={initialEndDate}
                  label="Due Date To"
                />
                <div
                  className="advanced-search-container"
                  onClick={handleOpenFilter}
                >
                  <FilterListIcon sx={{ width: 20, height: 20 }} />
                  <p className="advanced-search-text">Advanced Search</p>
                  {anchorEl ? (
                    <ArrowDropUp sx={{ width: 24, height: 24 }} />
                  ) : (
                    <ArrowDropDownIcon sx={{ width: 24, height: 24 }} />
                  )}
                </div>
                <FilterMenu
                  startDate={startDate}
                  endDate={endDate}
                  actionTypes={actionTypes}
                  providerLists={providerLists}
                  categories={categories}
                  insuranceTypeOptions={insuranceTypeOptions}
                  insurancePlanNameOptions={insurancePlanNameOptions}
                  programNames={programNames}
                  anchorEl={anchorEl}
                  setAnchorEl={setAnchorEl}
                  checkedProviders={checkedProviders}
                  setCheckedProviders={setCheckedProviders}
                  checkedCategories={checkedCategories}
                  setCheckedCategories={setCheckedCategories}
                  checkedAction={checkedAction}
                  setCheckedAction={setCheckedAction}
                  checkedInsuranceTypes={checkedInsuranceTypes}
                  setCheckedInsuranceTypes={setCheckedInsuranceTypes}
                  checkedInsurancePlanNames={checkedInsurancePlanNames}
                  setCheckedInsurancePlanNames={setCheckedInsurancePlanNames}
                  checkedProgramNames={checkedProgramNames}
                  setCheckedProgramNames={setCheckedProgramNames}
                  setDateFilterDefault={setDateFilterDefault}
                  handleStartDateChange={handleStartDateChange}
                  setShowCompleted={setShowCompleted}
                  setSortType={setSortType}
                  handleEndDateChange={handleEndDateChange}
                  showCompleted={showCompleted}
                  sortType={sortType}
                  initialEndDate={initialEndDate}
                  initialStartDate={initialStartDate}
                />
              </Grid>
            </Grid>

            <Grid container className="p-4">
              {badgeData?.length > 0 && (
                <>
                  <div className="badge-container">
                    <BadgeList
                      badgeData={badgeData}
                      setBadgeData={setBadgeData}
                      handleDeleteBadge={handleDeleteBadge}
                      background="none"
                    />
                  </div>
                </>
              )}
              <Grid item xs={12}>
                <Box width={"100%"}>
                  <Box
                    sx={{
                      display: "flex",
                      paddingBottom: "10px",
                      py: 2,
                      width: "100%",
                    }}
                    className="box-header"
                  >
                    <Box
                      sx={{ flexBasis: "120px", textAlign: "left" }}
                      className="action-table-header"
                    >
                      Due Date
                    </Box>
                    <Box
                      sx={{ flexBasis: "18%", textAlign: "left", ml: 2 }}
                      className="action-table-header"
                    >
                      Status
                    </Box>
                    <Box
                      sx={{ flexBasis: "20%", textAlign: "left" }}
                      className="action-table-header"
                    >
                      Patient
                    </Box>
                    <Box
                      sx={{ flexBasis: "20%", textAlign: "left" }}
                      className="action-table-header"
                    >
                      Action Title
                    </Box>
                    <Box
                      sx={{ flexBasis: "20%", textAlign: "left" }}
                      className="action-table-header"
                    >
                      Subtext
                    </Box>
                    <Box
                      sx={{ flexBasis: "20%", textAlign: "left" }}
                      className="action-table-header"
                    >
                      Provider
                    </Box>
                    <Box
                      sx={{ flexBasis: "20%", textAlign: "center" }}
                      className="action-table-header"
                    >
                      Actions
                    </Box>
                  </Box>

                  <Box
                    className="action-queue-layout"
                    sx={{
                      overflowY: "auto",
                      height: "calc(100vh - 400px)",
                      position: "relative",
                      "& .sticky-month-header": {
                        position: "sticky",
                        top: 0,
                        zIndex: 9,
                        backgroundColor: "#F5F5F5",
                      },
                    }}
                  >
                    {globalActionQueues.length > 0 ? (
                      Object.entries(
                        globalActionQueues.reduce((acc, aq) => {
                          const month = moment(aq.due_date)
                            .format("MMMM - YYYY")
                            .toUpperCase();
                          if (!acc[month]) acc[month] = [];
                          acc[month].push(aq);
                          return acc;
                        }, {})
                      ).map(([month, items]: [string, ActionQueueItem[]]) => (
                        <div key={month}>
                          <MonthHeader month={month} />
                          {items.map((aq, index) => (
                            <ActionRow
                              key={index}
                              aq={aq}
                              providers={providers}
                              reloadData={(response_resource) =>
                                fetchActionQueues(page - 1, response_resource)
                              }
                              reloadCount={() => props.setRefreshStats(true)}
                            />
                          ))}
                        </div>
                      ))
                    ) : (
                      <Box sx={{ textAlign: "center", py: 2 }}>
                        No actions found for the selected date range.
                      </Box>
                    )}
                    {hasMoreData && (
                      <Stack
                        width={"100%"}
                        justifyContent={"center"}
                        display={"flex"}
                        alignItems={"center"}
                        my={2}
                      >
                        <Link
                          sx={{ textDecoration: "underline" }}
                          onClick={(e) => {
                            e.preventDefault();
                            handleLoadMore();
                          }}
                        >
                          Load More
                        </Link>
                      </Stack>
                    )}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default GlobalActionQueue;
